import _ from 'lodash';
import React, { Component } from 'react';
import './styles.scss';
import { EmmaAppWebViewDeepLink as DeepLink } from '../../../../types/configTypes';
import { getCardViewState } from '../../selectors/ehubSelector';
import { resolveLocalizedText, resolvePublicAssets } from '../../../../utils';
import { CardViewState } from '../../reducers';
import { openDisclaimer } from '../../../../modules/emma-common/actions';
import { goto } from '../../../../actions/historyActions';
import {
  getPoPartnerServiecs,
  getCwpPartnerServiecs,
  isCWP,
} from '../../../home/selectors/serviceSelectors';
import { EmmaPartnerService } from '../../../home/types/EmmaPartnerService';
import { getHaveReadNewFeatures } from '../../../../selectors/sideBarItemSelectors';
import { getDefaultRedDotMaxCount } from '../../../../selectors/configSelectors';
import { NewFeaturepiRes } from '../../../../types/sideBarItemTypes';
import { pushHaveReadNewFeatureSingle } from '../../../../actions/sideBarItemActions';
export interface CardViewProps {
  ehubId?: string;
  cardViewId?: string;
  isLocked?: boolean;
  title?: string;
  subtitle?: string;
  shortDesc?: string;
  icon?: any;
  lockedIcon?: any;
  deepLink?: DeepLink;
  deepLinkLock?: DeepLink;
  onClickCardView: (
    isLocked: boolean,
    enableNewFeatureDot: boolean,
    deepLinkLock?: any,
    newFeatures?: EmmaPartnerService,
  ) => void;
  reducerSubName?: string;
  newFeatures?: EmmaPartnerService;
  haveReadNewFeatures?: Array<NewFeaturepiRes>;
  redDotMaxCount: number;
}

export class CardView extends Component<CardViewProps, CardViewState> {
  constructor(props: any = {}) {
    super(props);
  }

  componentDidMount() {}

  isShowRedDot() {
    const { haveReadNewFeatures, redDotMaxCount, newFeatures, cardViewId } =
      this.props;
    const NewFeaturesResult = _.find(
      haveReadNewFeatures,
      (item: { id: string }) => item.id === cardViewId,
    );
    const clickCount = NewFeaturesResult ? NewFeaturesResult['clickCount'] : 0;
    const enableInNewFeatureDot = clickCount < redDotMaxCount ? true : false;
    const isShowRedDot =
      newFeatures &&
      newFeatures.id &&
      newFeatures.enableNewFeatureDot &&
      enableInNewFeatureDot
        ? true
        : false;
    return isShowRedDot;
  }

  render() {
    const {
      ehubId,
      cardViewId,
      isLocked,
      title,
      subtitle,
      shortDesc,
      icon,
      lockedIcon,
      deepLinkLock,
      onClickCardView,
      newFeatures,
    } = this.props;

    const link = `emma-e-hub/details-view?ehub_id=${ehubId}&ehub_details_id=${cardViewId}`;
    const enableNewFeatureDot = this.isShowRedDot();
    return (
      <div className="card-view-container">
        <a
          onClick={() => {
            onClickCardView(
              isLocked || false,
              enableNewFeatureDot,
              deepLinkLock,
              newFeatures,
            );
            goto(link);
          }}
          data-enable-ga
          data-ga-type="button"
        >
          <div className="card-view">
            {enableNewFeatureDot && (
              <div className="card-view__new-feature-dot"></div>
            )}
            <div className="card-view__left-container">
              <div className="card-view__icon-container">
                {!isLocked && <img className="card-view__icon" src={icon} />}
                {isLocked && (
                  <img className="card-view__icon" src={lockedIcon} />
                )}
              </div>
            </div>
            <div className="card-view__right-container">
              <div className="card-view__title">{title}</div>
              <div className="card-view__subtitle">{subtitle}</div>
              <div className="card-view__shortDesc">{shortDesc}</div>
            </div>
          </div>
        </a>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const cardViewState = getCardViewState(
      state,
      ownProps.cardViewId,
      ownProps.reducerSubName,
    );
    const partnerServices = isCWP(state)
      ? getCwpPartnerServiecs(state)
      : getPoPartnerServiecs(state);
    const NewFeaturesResult = _.find(
      partnerServices,
      (item: { id: string }) => item.id === ownProps.cardViewId,
    );
    const haveReadNewFeature = getHaveReadNewFeatures(state);
    const redDotMaxCount =
      NewFeaturesResult && NewFeaturesResult.redDotMaxCount
        ? NewFeaturesResult.redDotMaxCount
        : getDefaultRedDotMaxCount(state);
    return {
      title: cardViewState.title
        ? resolveLocalizedText(cardViewState.title)
        : '',
      subtitle: cardViewState.subtitle
        ? resolveLocalizedText(cardViewState.subtitle)
        : '',
      icon: resolvePublicAssets(cardViewState.icon).replace('.png', '@3x.png'),
      lockedIcon: resolvePublicAssets(cardViewState.lockedIcon).replace(
        '.png',
        '@3x.png',
      ),
      shortDesc: cardViewState.shortDesc
        ? resolveLocalizedText(cardViewState.shortDesc)
        : '',
      deepLink: cardViewState.deepLink,
      deepLinkLock: cardViewState.deepLinkLock,
      newFeatures: NewFeaturesResult,
      haveReadNewFeatures: haveReadNewFeature
        ? haveReadNewFeature.features
        : undefined,
      redDotMaxCount: redDotMaxCount,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onClickCardView: (
        isLocked: boolean,
        enableNewFeatureDot: boolean,
        deepLinkLock?: any,
        newFeatures?: EmmaPartnerService,
      ) => {
        if (newFeatures && newFeatures.id && enableNewFeatureDot) {
          dispatch(
            pushHaveReadNewFeatureSingle(
              newFeatures.id,
              1,
              newFeatures.redDotMaxCount,
            ),
          );
        }
        if (isLocked && deepLinkLock) {
          const { disclaimer } = deepLinkLock.query;
          if (disclaimer) {
            dispatch(openDisclaimer(disclaimer, {}, true));
          }
        }
      },
    };
  }
}
